import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { ComplaintBooks } from "../Model/ComplaintBooks";
import ComplaintBookRepository from "../Repository/ComplaintBookRepository";

export interface ComplaintBooksUsecase {
    invoke: (page: number, pageSize: number, search: string) => Promise<PaginationResult<ComplaintBooks>>;
}

export class GetComplaintBooks implements ComplaintBooksUsecase{

    private repo: ComplaintBookRepository;

    constructor(_repo: ComplaintBookRepository){
        this.repo = _repo;
    }
    
    async invoke(page: number, pageSize: number, search: string) {

        const getData = await this.repo.getComplaintBooks(page, pageSize, search);

        return getData;

    }


}